import { css } from '@/styled-system/css';

export const leadManagementHeaderStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  paddingBlock: 'default',
  marginTop: 'default',
  gap: 'default',
});

export const leadManagementTitleRowStyles = css.raw({
  marginTop: 'loose',
  marginBottom: { xlDown: 'default', xl: 'loose' },
  display: 'flex',
  // Stack the title and button on phones so the button label doesn't get squeezed.
  flexDirection: { base: 'column', md: 'row' },
  alignItems: { base: 'flex-start', md: 'center' },
  justifyContent: 'space-between',
  gap: 'default',
});
